import { RouteNames } from "@/constants/router";
import {
  createRouter,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from "vue-router";
import BaseLayout from "../views/layout/BaseLayout.vue";
import CustomerDisplay from "../views/Customer-Display/Customer-Display.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/booking",
  },
  {
    path: "/log-in",
    component: BaseLayout,
    redirect: "/login",
    children: [
      {
        path: "/login",
        component: () => import("@/views/Login.vue"),
        name: RouteNames.Login,
        meta: {
          title: "login",
        },
      },
    ],
  },
  {
    path: "/booking",
    component: BaseLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/Booking/Booking.vue"),
        name: RouteNames.Booking,
        meta: {
          title: "dashboard",
          icon: "#icondashboard",
          affix: true,
        },
      },
      {
        path: "complete-order",
        component: () => import("@/views/Booking/components/CompleteOrder.vue"),
        name: RouteNames.BookingCompleteOrder,
        meta: {
          title: "complete-order",
          affix: true,
        },
      },
      // {
      //   path: "payment",
      //   name: RouteNames.BookingPayment,
      //   component: () =>
      //     import(/* webpackChunkName: "home" */ "@/views/Booking/components/Payment.vue"),
      //   meta: {
      //     title: "payment",
      //     affix: true,
      //   },
      // },
    ],
  },
  {
    path: "/customer-display",
    component: CustomerDisplay,
  },
];

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
